import { PushNotifications } from '@capacitor/push-notifications';
import { FirebaseMessaging } from '@capacitor-firebase/messaging';

export async function initPush(onToken, navigate) {
  const permStatus = await PushNotifications.requestPermissions();
  if (permStatus.receive !== 'granted') return;

  await PushNotifications.register();

  PushNotifications.addListener('registrationError', (err) => {
    console.error('Push registration error', err);
  });

  const { token } = await FirebaseMessaging.getToken();

  onToken(token);

  FirebaseMessaging.addListener('tokenReceived', ({ token }) => {
    onToken(token);
  });

  FirebaseMessaging.addListener('notificationActionPerformed', (action) => {
    console.log('Action performed', action);
    const route = action.notification?.data?.route;
    if (route) {
      navigate(route);
    }
  });

  console.log('Firebase configured');
}

export function getPlatform() {
  const ua = navigator.userAgent.toLowerCase();
  if (ua.includes('android')) return 'android';
  if (ua.includes('iphone') || ua.includes('ipad')) return 'ios';
  return 'unknown';
}
